// extracted by mini-css-extract-plugin
module.exports = {"wave_box":"ParkRoad_wave_box__377-z","wave_box_title":"ParkRoad_wave_box_title__M5PYL","wave_item":"ParkRoad_wave_item__39MIk","wave_item_label":"ParkRoad_wave_item_label__2zF73"};